// iframe内でのstorageアクセスエラーを抑制（最優先で実行）
(() => {
  if (typeof window === 'undefined') return;

  // Promiseのunhandledrejectionエラーを抑制
  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message || String(event.reason);
    // "Access to storage is not allowed from this context" エラーを静かにキャッチ
    if (message.includes('Access to storage is not allowed') ||
      message.includes('storage is not allowed') ||
      message.includes('storage is not allowed from this context')) {
      event.preventDefault();
      event.stopPropagation();
      // 開発環境でのみコンソールに記録（本番では完全に抑制）
      if (import.meta.env.DEV) {
        console.debug('[Chatbot] Storage access prevented (expected in iframe/cross-origin)');
      }
    }
  });

  // 通常のエラーも同様に処理
  const originalError = console.error;
  console.error = (...args: any[]) => {
    const message = args.join(' ');
    if (message.includes('Access to storage is not allowed')) {
      // このエラーは抑制
      return;
    }
    originalError.apply(console, args);
  };
})();

import { createRoot } from "react-dom/client";
import ShadowApp from "./ShadowApp";

// DOM読み込み完了を確実に待つ
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}

async function main() {
  try {

    // 既存要素のチェック（重複防止）
    const existingElement = document.getElementById("otai");
    if (existingElement) {
      console.warn('Chatbot already initialized');
      return;
    }

    // 専用コンテナを作成
    const container = document.createElement("div");
    container.setAttribute("id", "otai");
    container.setAttribute("class", "otai");

    // 外部サイトでの確実な配置
    // pointer-events: none により、コンテナ自体はクリックを透過
    // 内部の実際のチャットボット要素のみが pointer-events: auto で操作可能
    container.style.cssText = `
      position: fixed;
      z-index: 2147483647;
      pointer-events: none;
      height: 100vh;
      width: 100vw;
      top: 0;
      left: 0;
      background: transparent;
      display: block;
    `;

    // body要素への安全な追加
    const bodyElement = document.querySelector("body");
    if (!bodyElement) {
      throw new Error('Body element not found');
    }

    bodyElement.appendChild(container);

    // React アプリの初期化
    // StrictModeを削除してAPI重複呼び出しを防止
    const root = createRoot(container);
    root.render(<ShadowApp />);

  } catch (error) {
    console.error('Chatbot initialization failed:', error);
  }
}
